<template>
    <div>
        <h3 class="columnTit">
            <span>行业报告</span><a href="https://amma.artron.net/report.php" target="_blank">查看更多</a>
        </h3>
        <div class="reportList">
            <template v-for="(item,i) in reportList">
                <dl class="fix" v-if="i<4" :key="i">
                    <a :href="'https://amma.artron.net/reportDetail.php?id='+item.id" target="_blank">
                        <dt>
                            <div class="imgBox">
                                <el-image
                                    style="width: 100%; height: 100%;"
                                    :src="item.coverPicture" fit="contain">
                                    <div slot="placeholder" class="image-slot">
                                        加载中<span class="dot">...</span>
                                    </div>
                                    <div slot="error" class="el-image__error">
                                        <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                    </div>
                                </el-image>
                            </div>
                        </dt>
                        <dd>
                            <h3 class="name">{{item.title}}</h3>
                            <div class="reportBot">
                                <template v-if="item.sale_type == 0">
                                    <p><span class="flag">免费</span></p>
<!--                                    <p><span class="original">原价：¥{{item.originPrice}}</span></p>-->
                                </template>
                                <template v-if="item.sale_type == 1">
                                    <p><span class="flag">会员免费</span></p>
                                </template>
                                <template v-if="item.sale_type == 2">
                                    <p><span class="flag">会员专享</span>
                                        <span class="price" v-if="item.vipPrice > 0">¥{{item.vipPrice}}</span></p>
                                    <p><span class="original" v-if="item.originPrice > 0">原价：¥{{item.originPrice}}</span></p>
                                </template>
                                <template v-if="item.sale_type == 3">
                                    <p><span class="flag">会员优享</span>
                                        <span class="price" v-if="item.vipPrice > 0">¥{{item.vipPrice}}</span></p>
                                    <p><span class="original" v-if="item.originPrice > 0">原价：¥{{item.originPrice}}</span></p>
                                </template>
                            </div>
                        </dd>
                    </a>
                </dl>
            </template>
        </div>
    </div>
</template>

<script>
import {getReport} from "@/api/index";

export default {
    name: "IndexReport",
    data(){
        return{
            reportList:[]
        }
    },
    mounted() {
        this.getReport()
    },
    methods:{
        getReport(){
            getReport().then((res) => {
                this.reportList = res.data.list
            });
        },
    }
}
</script>

<style scoped lang="scss">
/*报告列表*/
.reportList{
    dl{margin-bottom: 20px;}
    dl:last-child{margin-bottom: 0;}
    a{display: flex;justify-content: center;}
    dt{width:150px;height:200px;margin-right: 20px;overflow: hidden;border-radius: 4px;}
    .name{font-size: 16px;line-height: 24px;height:48px;display:-webkit-box;max-height: 44px;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-overflow: ellipsis;}
    dd{width:210px;}
    .reportBot{margin-top: 44px;
        p{line-height: 20px;margin-bottom: 14px;display:flex;align-items: center;}
        .flag{display:inline-block;padding:0 2px;width:52px;height:20px;line-height: 20px;color:#fff;font-size: 12px;background: linear-gradient(180deg, #E8C690 0%, #CD9457 100%);margin-right: 4px;border-radius: 4px;text-align: center;}
        .price{font-size: 20px;font-weight: bold;color:#F5222D;}
        .original{color:#8C8C8C;text-decoration: line-through;}
    }
}
</style>